module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1502-64a97e6deaffd20b650a2c8d9ce7acf2.png";